import Vue from 'vue';
import App from './App.vue';
import axios from 'axios'
import Qs from 'qs'
import config from './config/index';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';

// 导入api  挂载
import api from '@/api/api';
Vue.prototype.$api = api;

// 导入moment  挂载
import moment from 'moment';
Vue.prototype.$moment = moment;

// 适配
import 'amfe-flexible/index.js';

// 样式引入
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/main.scss';

// 引入vconsole调试
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
// Vue.prototype.vConsole = vConsole;

Vue.prototype.axios = axios;
Vue.prototype.dfAxios = axios; // dynamicform axios
Vue.prototype.qs = Qs;
Vue.use(config);
Vue.use(ElementUI);
Vue.config.productionTip = false;



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

